import React from 'react';
import { getValidDate } from '@/pages/intelligence/utils/common';

const IMG_TYPE_MAP: { [keyName: string]: number } = {
  mobile: 1,
  pc: 2,
  console: 3,
};

export const getTranslateText = (
  lang: 'original' | 'en' | 'cn' | (string & {}),
  texts: { original?: string; en?: string; cn?: string },
): string => {
  const { original, en, cn } = texts ?? {};
  const text = original ?? en ?? cn ?? '';
  if (lang === 'original') return original ?? text;
  if (lang === 'en') return en ?? text;
  return cn ?? text;
};

/**
 * 标记指定关键字高亮（以关键字的特殊字符分隔后的数组单个值为单位，不区分大小写）
 * @param {string} text 需要处理的原字符串
 * @param {string} key 需要标记的字符串关键字
 */
export const keyArrRender = (text: string, key?: string[]) => {
  if (text && typeof text === 'string' && Array.isArray(key) && key?.length > 0) {
    const charIndexCache: {
      [key: string]: string;
    } = {};
    const allKeys = [];
    let matchWords;
    let i;
    const textOrigin = text;
    text = text.toLowerCase();
    for (i = 0; i < key?.length; i++) {
      matchWords = text.match(new RegExp(key[i].replace(/([^\w]{1})/gi, '\\$1'), 'ig'));
      if (matchWords) {
        if (matchWords?.length > 1) {
          allKeys.push(matchWords);
        } else {
          allKeys.push(matchWords[0]);
        }
      }
    }
    const readChar = (text: string, word: string) => {
      const indexStart = text.indexOf(word);
      if (indexStart >= 0) {
        let replaceWord = '';
        const indexEnd = indexStart + word?.length;
        for (let i = indexStart; i < indexEnd; i++) {
          if (!charIndexCache[i]) {
            charIndexCache[i] = text.charAt(i);
          }
          replaceWord += '#';
        }
        text = text.replace(word, replaceWord);
      }
      return text;
    };
    allKeys.forEach((word) => {
      if (typeof word === 'string') {
        readChar(text, word.toLowerCase());
      } else {
        let textCopy = text.substring(0);
        for (let i = 0; i < word?.length; i++) {
          textCopy = readChar(textCopy, word[i].toLowerCase());
        }
      }
    });
    let word = '';
    let newText = '';
    for (let i = 0, len = text?.length; i < len; i++) {
      if (charIndexCache[i]) {
        if (!word) {
          // newText += "<Fragment style='background:#CCE3FF; padding:2px 5px; line-height: 14px;'>";
          newText += "<Fragment class='action-text'>";
        }
        word += textOrigin.charAt(i);
        if (i === text?.length - 1) {
          newText += `${word}</Fragment>`;
        }
      } else {
        if (word) {
          newText += `${word}</Fragment>`;
          word = '';
        }
        newText += textOrigin.charAt(i);
      }
    }
    // return <span dangerouslySetInnerHTML={{ __html: newText }} />;
    return newText;
  }
  return text;
};

export const getTranslateAndHighlightText = (
  texts: { original?: string; en?: string; cn?: string },
  option: {
    lang: 'original' | 'en' | 'cn' | (string & {});
    keywords?: string[];
  },
): string | React.ReactElement => {
  const translateText = getTranslateText(option?.lang, texts);
  return keyArrRender(translateText, option?.keywords);
};

export const handleNewGamesData = (data: any[]): any[] => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => {
    const {
      entity_type: entityType,
      eu_id: euId,
      name,
      source,
      cover,
      release_time: releaseTime,
      array_genre: genres,
    } = item ?? {};
    return {
      eu_id: euId ?? '',
      entityType: entityType ?? '',
      source: source ?? '',
      name: source ?? '-',
      title: name ?? '-',
      type: IMG_TYPE_MAP?.[entityType?.toLowerCase()] ?? 1,
      img: cover ?? '',
      time: releaseTime ? getValidDate(releaseTime, 'YYYY-MM-DD') : '-',
      list: genres ?? [],
    };
  });
};

export const handleActivities = (data: any[]): any[] => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => {
    const { activity_type: activityType, announced_on: announcedOn, activity } = item ?? {};
    return {
      title: activityType ?? '-',
      time: announcedOn ? getValidDate(announcedOn, 'YYYY-MM-DD') : '-',
      text: activity ?? '-',
    };
  });
};
